<!--
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-10-08 15:32:08
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-03-16 11:03:17
 * @FilePath: \xm-runing-main\src\layouts\page\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <template v-if="analysisSet!==true">
    <KeepAlive v-show="!$route.name || $route.name === 'PageNotFound'|| $route.name === 'PageNotFoundSon'">
      <div class="go-page" id="frame"></div>
    </KeepAlive>

    <RouterView v-show="!(!$route.name || $route.name === 'PageNotFound'|| $route.name === 'PageNotFoundSon')"
                id="main-roter-view"
                v-slot="{Component}">
      <template v-if="getOpenKeepAlive && currentRouteKeepAlive">
        <KeepAlive :max="20" :include="cachedViewNames">
          <component 
            :is="wrapComponent(Component, route.fullPath)"
            :key="route.fullPath" 
          />
        </KeepAlive>
      </template>
      <!-- KeepAlive未启用或当前路由不需要缓存 -->
      <component v-else
                 :key="route.fullPath" 
                 :is="Component" />
    </RouterView>
  </template>

  <div v-if="analysisSet">
    <a-result
      status="success"
      title="请在左侧选择皮肤以及系统主题颜色"
      sub-title="个人设置的主题不会影响其他人员，只会对本人起效."
    >
      <template #extra>
      </template>
    </a-result>
  </div>
  <KeepAlive v-show="getCanEmbedIFramePage">
    <FrameLayout/>
  </KeepAlive>
</template>

<script lang="ts">
import {Result as AResult} from 'ant-design-vue'
import {computed, defineComponent, h} from 'vue';
import FrameLayout from '@/layouts/iframe/index.vue';
import {useRootSetting} from '@/hooks/setting/useRootSetting';
import {useMultipleTabStore} from '@/store/modules/multipleTab';

// 缓存包装器组件的映射表
const wrapperCache = new Map();

export default defineComponent({
  name: 'PageLayout',
  components: {FrameLayout, AResult},
  props: {
    analysisSet: {}
  },
  setup() {
    const { getCanEmbedIFramePage, getOpenKeepAlive } = useRootSetting();
    const tabStore = useMultipleTabStore();
    const route = useRoute();

    // 是否启用 KeepAlive
    const currentRouteKeepAlive = computed(() => {
      return getOpenKeepAlive.value && route.meta.keepAlive;
    });

    // 获取缓存的tab列表
    const cachedTabList = computed(() => {
      return tabStore.getCachedTabList;
    });

    // 将fullPath转换为合法的组件名称
    const pathToComponentName = (fullPath: string) => {
      // 移除特殊字符，只保留字母数字和下划线
      return 'Cached_' + fullPath.replace(/[^a-zA-Z0-9]/g, '_');
    };

    // 需要缓存的组件名列表
    const cachedViewNames = computed(() => {
      const names = cachedTabList.value.map(path => pathToComponentName(path));
      console.log('[KeepAlive] include列表:', names);
      console.log('[KeepAlive] 对应路径:', cachedTabList.value);
      return names;
    });

    // 为组件创建包装器，赋予唯一的name
    const wrapComponent = (component: any, fullPath: string) => {
      if (!component) return component;
      
      const componentName = pathToComponentName(fullPath);
      
      // 如果已经创建过包装器，直接返回
      if (wrapperCache.has(componentName)) {
        return wrapperCache.get(componentName);
      }
      
      // 创建新的包装器组件
      const wrapper = defineComponent({
        name: componentName,
        setup(props, { attrs, slots }) {
          return () => h(component, { ...attrs }, slots);
        }
      });
      
      wrapperCache.set(componentName, wrapper);
      console.log('[Wrapper] 创建包装器:', componentName);
      
      return wrapper;
    };

    return {
      route,
      currentRouteKeepAlive,
      getCanEmbedIFramePage,
      getOpenKeepAlive,
      cachedViewNames,
      wrapComponent,
    };
  },
});
</script>
<style type="text/css" lang="less">
.go-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  &#frame {
    position: relative;
    z-index: 10;
    padding: 12px
  }

}

#main-roter-view {
  padding: 12px;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
}

.page-router-view-body {
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
